define(function(require) {
	const Marionette = require('backbone.marionette');
	const ViewManager = require('civicsUtils/view_manager');
	const tpl = require('civicsViews/core/confirmation/templates/t_itv_confirmation.hbs');

	return Marionette.ItemView.extend({
		// template: tpl,
		tagName: 'div',
		className: 'v_itv_confirmation',
		modelEvents: {
			change: 'render'
		},
		ui:{
			cancelButton:'.btn-cancel-confirmation'
		},
		events: {
			'click .btn-cancel-confirmation': 'cancelConfirmation',
			'click .bbm-btn-close': 'closeConfirmation',
			'click .btn-ok-confirmation': 'okConfirmation',
			'click .btn-saveexit-confirmation': 'saveExitConfirmation'
		},
		initialize: function(options) {
			if (options.model)
				this.model = options.model;
			this.modalMessage = options.message;
			this.modalTitle = options.title;
			this.showCancelButton = options.showCancelButton;
			this.cancelCallback = options.cancelCallback;
			this.cancelCallbackOptions = options.cancelCallbackOptions;
			this.cancelCallbackValidation = options.cancelCallbackValidation;
			this.closeCallback = options.closeCallback,
			this.okCallback = options.okCallback;
			this.okCallbackOptions = options.okCallbackOptions;
			this.useCloseFromOkCallBack = options.useCloseFromOkCallBack;
			this.modalCancelLabel = options.cancelLabel || i18n.t('CIVICS.COMMON.CANCEL');
			this.modalOkLabel = options.okLabel || i18n.t('CIVICS.COMMON.OK');
			this.template = options.template || tpl;
      		this.modalRegion = options.modalRegion;
			this.templateHelpers = _.extend({
				modalMessage: this.modalMessage,
				modalTitle: this.modalTitle,
				modalCancelLabel: this.modalCancelLabel,
				modalOkLabel: this.modalOkLabel,
				showCancelButton : this.showCancelButton == undefined ? true : this.showCancelButton
			}, options.templateHelpers);
		},
		onRender: function() {
			ViewManager.resetErrorMessages(this);
			this.$el.find('textarea:not([aria-labelledby|="character-count-label"])').each(function(index, ta){
				$(ta).maxlength();
			});
			this.$el.find('input[type="text"]:not([aria-labelledby|="character-count-label"])').each(function(index, tb){
				$(tb).maxlength();
			});

		},
		cancelConfirmation: function() {
			if(this.cancelCallbackValidation){//if validate on cancel, do validation
				if(!this.validate()) return;//if validation fails, stop
			}
			if(this.modalRegion) {
				this.modalRegion.hideModal();
			} else {
				this.destroy();
			}
			if (this.cancelCallback)
				this.cancelCallback(this.model, this.cancelCallbackOptions);
		},
		closeConfirmation:function(){
			if (this.closeCallback)
				this.closeCallback();

			if(this.modalRegion) {
				this.modalRegion.hideModal();
			} else {
				this.destroy();
			}
		},
		validate: function(){
			var reqInputs = this.$el.find(':input[required]');
			var errors;
			$.each(reqInputs, function(index, el) {
				if(!$(this).val() || $(this).val().trim() == ''){//might have to take into account numbers
					if(!errors) errors = {};
					errors[$(this).attr('name')] = i18n.t('CIVICS.COMMON.VALUE_REQ_ERROR');
				}
			});
			if(errors){//errors, validation failed
				ViewManager.errorToWindow({validationError: errors}, this);
				return false;
			} else {//no errors, validation passed
				return true;
			}
		},
		okConfirmation: function() {
			if(!this.validate()) return;//if validation fails, stop
			var close = true;
			var closeFromCallBack;
			if (this.okCallback)
				closeFromCallBack = this.okCallback(this.model, this.okCallbackOptions);
			if ( this.useCloseFromOkCallBack ){
				close = closeFromCallBack;
			}
			if ( close === true ){
				if(this.modalRegion) {
					this.modalRegion.hideModal();
				} else {
					this.destroy();
				}
			}
		},
		saveExitConfirmation: function(){
			if(this.cancelCallbackValidation){
				if(!this.validate()) return;
			}
			var close = true;
			var closeFromCallBack;
			if (this.cancelCallback)
				closeFromCallBack = this.cancelCallback(this.model, this.cancelCallbackOptions);
			if(this.useCloseFromOkCallBack){
				close = closeFromCallBack;
			}
			if(close === true ){
				if(this.modalRegion) {
					this.modalRegion.hideModal();
				} else {
					this.destroy();
				}
			}
		},
		templateHelpers: function() {
			return this.templateHelpers;
		}
	});
});
